import {
  GetMarketplaceFormQuestionsDocument,
  GetMarketplaceFormQuestionsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

// In next iterations of installation settings review why do we use this in many places
export const useGetMarketplaceFormQuestions = (
  variables: GetMarketplaceFormQuestionsQueryVariables,
  isInstallable: boolean
) => {
  const { loading, data } = useQuery(GetMarketplaceFormQuestionsDocument, {
    variables,
    skip: isInstallable,
  })

  return {
    loading,
    data: data?.marketplace.formQuestionsConnection.nodes || [],
  }
}
